import './SettingsToggle.scss';

interface SettingsToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function SettingsToggle({ label, checked, onChange, disabled }: SettingsToggleProps) {
  return (
    <label className="settings-toggle">
      <span className="settings-toggle__label">{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        className={`settings-toggle__switch ${checked ? 'settings-toggle__switch--on' : ''}`}
        onClick={() => onChange(!checked)}
        disabled={disabled}
      >
        <span className="settings-toggle__thumb" />
      </button>
    </label>
  );
}
